import { DefaultProps } from 'typings'
import { styles } from './styles'

export function NeutralAlert(props: DefaultProps) {
  return (
    <div role="alert" className={styles.container}>
      {props.children}
    </div>
  )
}
